import React from "react";
import moment from "moment";

const Points = ({
  data,
  x,
  y,
  showTooltip,
  hideTooltip,
  formatKey,
  formatValue,
}) => {
  // remove last & first point
  // var data = pointsData.splice(1);
  // data.pop();

  const circles = data.map((d, idx) => (
    <circle
      className="dot"
      r="7"
      cx={x(d[0])}
      cy={y(d[1])}
      fill="#7dc7f4"
      stroke="#3f5175"
      strokeWidth="5px"
      key={idx}
      onMouseOver={showTooltip}
      onMouseOut={hideTooltip}
      data-key={formatKey(d[0], idx)}
      data-value={formatValue(d[1], idx)}
    />
  ));

  return <g>{circles}</g>;
};

export default Points;



// WEBPACK FOOTER //
// ./components/employee/wellness/graph/points.js